import { type EditorState, Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import { Extension } from '@tiptap/react';

const tableActiveCellKey = new PluginKey('tableActiveCell');

/** Tag the selected cell with `.tiptap-active-cell` so the CSS anchor-name is set and the
 * per-cell menu can position itself against the cell without JS measurement. */
const activeCellDecorations = (state: EditorState): DecorationSet => {
  const { $from } = state.selection;
  for (let depth = $from.depth; depth > 0; depth--) {
    const node = $from.node(depth);
    const role = node.type.spec.tableRole;
    if (role === 'cell' || role === 'header_cell') {
      const from = $from.before(depth);
      return DecorationSet.create(state.doc, [
        Decoration.node(from, from + node.nodeSize, { class: 'tiptap-active-cell' }),
      ]);
    }
  }
  return DecorationSet.empty;
};

export const TableActiveCell = Extension.create({
  name: 'tableActiveCell',
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: tableActiveCellKey,
        props: {
          decorations: activeCellDecorations,
        },
      }),
    ];
  },
});
